/**
 * What a charstring declares about its hints: the horizontal and vertical stems, and the mask that
 * says which of them hold for the outline drawn next. Stems come first in the charstring; a mask
 * can switch them on and off as the outline goes on (hint substitution).
 *
 * Portions ported from FreeType (FreeType Project License).
 * Copyright 2007-2014 Adobe Systems Incorporated.
 * See THIRD-PARTY-NOTICES.md.
 */
import { MalformedCharstring } from './cffOperandStack';
/** `CF2_MAX_HINTS`: the horizontal and vertical stems together that a hint mask can address. */
export const MAX_STEMS = 96;
/** `CF2_HintMaskRec`: one bit per stem, horizontal stems first, the first stem in the top bit of the first byte. */
export class HintMask {
    /** True once a mask is set: later stems are then ignored. */
    isValid = false;
    /** True from setting the mask until a hint map uses it. */
    isNew = false;
    bits = [];
    get bitCount() {
        return this.bits.length;
    }
    /** Reads the mask for `stemCount` stems from `readByte` (`cf2_hintmask_read`). No byte is read for no stems. */
    read(stemCount, readByte) {
        this.setCount(stemCount);
        let byte = 0;
        for (let i = 0; i < stemCount; i++) {
            if (i % 8 === 0)
                byte = readByte();
            this.bits[i] = ((byte >> (7 - (i % 8))) & 1) === 1;
        }
    }
    /** Turns all `stemCount` stems on (`cf2_hintmask_setAll`): the mask a glyph without a `hintmask` has. */
    setAll(stemCount) {
        this.setCount(stemCount);
        this.bits.fill(true);
    }
    /** Whether stem `index` is on. */
    isOn(index) {
        return this.bits[index] ?? false;
    }
    setCount(stemCount) {
        if (stemCount > MAX_STEMS)
            throw new MalformedCharstring(`${stemCount} stems are more than the ${MAX_STEMS} a mask holds`);
        this.bits = Array(stemCount).fill(false);
        this.isValid = true;
        this.isNew = true;
    }
}
export class GlyphHints {
    horizontalStems = [];
    verticalStems = [];
    mask = new HintMask();
    get stemCount() {
        return this.horizontalStems.length + this.verticalStems.length;
    }
}
//# sourceMappingURL=cffGlyphHints.js.map